export function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

export const nonNumericRegex = /^[A-Za-z\s]+$/;

export const sidebarData = [
  {
    id: 1,
    title: "Dashboard",
    link: "/dashboard",
    icon: "ti ti-home",
    subMenu: [],
  },
  {
    id: 2,
    title: "Booking Details",
    link: "/booking-view",
    icon: "ti ti-calendar",
    subMenu: [],
  },
  {
    id: 2,
    title: "Role",
    link: "/administration/role",
    icon: "ti ti-shield",
    subMenu: [],
  },

  {
    id: 3,
    title: "Product",
    link: "",
    icon: "ti ti-box",
    subMenu: [
      {
        id: 1,
        title: "Product",
        link: "/administration/product",
        subMenu: [],
      },
      {
        id: 2,
        title: "Category",
        link: "/administration/category",
        subMenu: [],
      },
      {
        id: 3,
        title: "Sub Category",
        link: "/administration/sub-category",
        subMenu: [],
      },
    ],
  },
  {
    id: 4,
    title: "Messages",
    icon: "ti ti-message-circle",
    subMenu: [],
  },

  {
    id: 5,
    title: "Team Management",
    link: "",
    icon: "ti ti-users",
    subMenu: [
      {
        id: 1,
        title: "Teams",
        link: "/manage-teams",
        subMenu: [],
      },
      {
        id: 2,
        title: "Players",
        link: "/manage-players",
        subMenu: [],
      },
      {
        id: 3,
        title: "Display Settings",
        link: "/manage-display",
        subMenu: [],
      },
    ],
  },
  {
    id: 6,
    title: "Other Settings",
    link: "",
    icon: "ti ti-settings",
    subMenu: [
      {
        id: 1,
        title: "Testimonials",
        link: "/administration/testimonials",
        subMenu: [],
      },
      {
        id: 2,
        title: "Coupons",
        link: "/administration/coupons",
        subMenu: [],
      },
    ],
  },
  {
    id: 7,
    title: "Invoice",
    link: "/administration/invoice",
    icon: "ti ti-file-invoice",
    subMenu: [],
  },
  {
    id: 8,
    title: "Quotation",
    link: "/administration/quotation",
    icon: "ti ti-file-text",
    subMenu: [],
  },
  // {
  //   id: 6,
  //   title: "Contact Us",
  //   link: "/administration/contact-us",
  //   icon: "ti ti-message-circle",
  //   subMenu: [],
  // },
];

export const dayNames = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
export const getNext7Days = (startDate = new Date(), count = 7) => {
  const monthNamesShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const days = [];
  for (let i = 0; i < count; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    days.push({
      day: dayNames[date.getDay()],
      date: date.getDate(),
      month: monthNamesShort[date.getMonth()],
      fullDate: date,
    });
  }
  return days;
};

export const getDateRangeForPrev1Next3Months = (referenceDate = new Date()) => {
  const monthNamesShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const days = [];
  // Start 1 month before referenceDate
  const startDate = new Date(referenceDate);
  startDate.setMonth(startDate.getMonth() - 1);
  // End 3 months after referenceDate
  const endDate = new Date(referenceDate);
  endDate.setMonth(endDate.getMonth() + 3);

  // Loop from startDate to endDate (inclusive)
  let currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    days.push({
      day: dayNames[currentDate.getDay()],
      date: currentDate.getDate(),
      month: monthNamesShort[currentDate.getMonth()],
      fullDate: new Date(currentDate),
    });
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return days;
};
